import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, useCallback, useContext } from 'react';
import './Textarea.scss';
import { isTouchDevice } from '../../utils';
import { FormItemContext } from '../form/FormItem';
export const Textarea = forwardRef(({ value, name, placeholder, isDisabled, isRequired, isInvalid: isInvalidProp, isHovered, testId, onChange, }, ref) => {
    const formItemContext = useContext(FormItemContext);
    const textareaRef = useRef(null);
    useImperativeHandle(ref, () => ({
        focus: () => {
            if (!isTouchDevice() && textareaRef.current) {
                const textarea = textareaRef.current;
                textarea.focus();
                const textLength = textarea.value.length;
                textarea.selectionStart = textLength;
                textarea.selectionEnd = textLength;
            }
        },
    }));
    const handleChange = useCallback((e) => {
        onChange(e, { name: name, value: e.target.value });
    }, [name, onChange]);
    const isInvalid = isInvalidProp || formItemContext.isInvalid;
    return (_jsxs("div", { className: 'sg-textarea', children: [_jsxs("div", { className: 'sg-textarea--element sg-textarea--shadow', "aria-disabled": isDisabled, "aria-invalid": isInvalid, "aria-required": isRequired, "data-hovered": isHovered, children: [value, "\u00A0"] }), _jsx("textarea", { id: formItemContext.id, className: 'sg-textarea--element', ref: textareaRef, name: name, value: value, disabled: isDisabled, required: isRequired, placeholder: placeholder, onChange: handleChange, "aria-describedby": formItemContext.descriptionId, "aria-invalid": isInvalid, "data-hovered": isHovered, "data-test-id": testId })] }));
});
//# sourceMappingURL=Textarea.js.map